import { useMemo } from 'react';

import cx from 'classnames';

import { MIXPANEL_EVENT_NAMES, MIXPANEL_SOURCES } from 'constants/mixpanelEventNames';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { ArrowSide } from 'styles/assets/icons';
import Box from 'UIKit/Box';

import {
  useResourcesMenus,
  // APP_DOWNLOAD_MENUS,
  HELP_MENUS,
} from './MenuSection.components';
import classes from './MenuSection.module.scss';
import {
  MENU_SECTIONS,
  SECTION_VARIANT,
  type MenuSection as MenuSectionProps,
} from './MenuSection.types';

const MenuSection = ({
  variant = SECTION_VARIANT.LIST,
  section,
  classnames = {},
}: MenuSectionProps) => {
  const resourceMenu = useResourcesMenus();

  const options = useMemo(() => {
    switch (section) {
      case MENU_SECTIONS.RESOURCES: {
        return resourceMenu;
      }

      case MENU_SECTIONS.HELP: {
        return HELP_MENUS;
      }

      // case MENU_SECTIONS.APP_DOWNLOAD: {
      //   return APP_DOWNLOAD_MENUS;
      // }

      default: {
        return [];
      }
    }
  }, [section, resourceMenu]);

  const onMenuClick = key => {
    if (key === 'deltaExchangeGlobal') {
      trackMixpanelEvent(MIXPANEL_EVENT_NAMES.DELTA_GLOBAL_LINK_CLICKED, {
        source: MIXPANEL_SOURCES.DOT_MENU,
        site_demarkation: 'webapp',
      });
    }
  };

  return (
    <Box
      data-testid={`menu-section-${section}`}
      className={classnames?.root}
      flex="flex"
      flexDir="row"
      wrap="wrap"
    >
      {options.map(
        ({ id, link, target, rel, label, icon, children, hide, containerClass, key }) => {
          if (hide) return null;

          return (
            <Box
              key={id}
              data-testid={id}
              as="a"
              flex="flex"
              flexDir={variant === SECTION_VARIANT.LIST ? 'row' : 'column'}
              href={link}
              target={target}
              rel={rel}
              onClick={() => onMenuClick(key)}
              className={cx(classnames?.option, classes.option, containerClass)}
            >
              {children ?? (
                <>
                  {icon}

                  <Box as="span" className={classnames?.label}>
                    {label}
                  </Box>

                  {variant === SECTION_VARIANT.LIST && (
                    <ArrowSide className={classnames?.arrow} />
                  )}
                </>
              )}
            </Box>
          );
        }
      )}
    </Box>
  );
};

export default MenuSection;
